import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const Navbar = () => {

    const logoutHandler = ( e: any ) => {

        console.log( 'logout' );
        localStorage.removeItem( "shreeDevToken" );
        window.location.reload( )

    }

    return (

        <NavbarWrapper>
            <div className="navbar-container">
                    <div className="navbar-logo">
                        <div className="logo">
                            <h3>ShreeDev</h3>
                        </div>
                    </div>
                    <div className="navlinks-container">
                        <ul className = 'navlinks'>
                            <li>
                                <NavLink to = '/' exact>Customers</NavLink>
                            </li>
                            <li>
                                <NavLink to = '/plots' exact>All Properties</NavLink>
                            </li>
                            <li>
                                <NavLink to = '/add-plots' exact>Add Properties</NavLink>
                            </li>
                            <li>
                                <NavLink to = '/login' exact onClick = { logoutHandler } >Logout</NavLink>
                            </li>
                        </ul>
                    </div>
            </div>
        </NavbarWrapper>
    )
}

export default Navbar;

const NavbarWrapper = styled.div`

    
    .navbar-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 40px;
        background: rgba(66, 36, 2, 0.836);
        border-bottom: 2px solid black;
    }
    
    .navlinks-container {
        height: 100%;
    }

    .navlinks a:hover {
        opacity: 0.3;
    }

    .navlinks a {
        color: white;
        font-size: 20px;
        display: inline;
        padding: 20px 10px;
        height: 100%;
        margin: 5px;
    }

    .navlinks a:active, .navlinks a.active {
        color: white;
        background: #aa650bbe;
        height: 100%;
    }  

    .navlinks a.active:hover {
        /* background: #b5c6d4; */
        opacity: 0.7;
    }

    .logo {
        font-size: 20px;
        padding: 18px 10px;

    }

    li {
        display: inline;
    }

`;